import { Pill, Switch, Text } from '@/ui'

import { BILLING_INTERVALS, type BillingInterval } from './recommendation.types'

interface BillingIntervalToggleProps {
  interval: BillingInterval
  onChange: (interval: BillingInterval) => void
  /** e.g. "Save 15%", or null when no offer has a computable saving. */
  savingHighlight: string | null
}

/**
 * Sits above the tier cards but outside the plan section, so the page can put it
 * in a row of its own — anything sharing a row with the cards would push the
 * due-today rail out of line with their top edge.
 */
export const BillingIntervalToggle: React.FC<BillingIntervalToggleProps> = ({
  interval,
  onChange,
  savingHighlight,
}) => (
  <div className="flex items-center gap-2">
    <Switch
      checked={interval === BILLING_INTERVALS.year}
      onCheckedChange={(checked) =>
        onChange(checked ? BILLING_INTERVALS.year : BILLING_INTERVALS.month)
      }
    />
    <Text className="font-medium">Annual Plan</Text>
    {savingHighlight && (
      <Pill color="green" variant="secondary" size="sm">
        {savingHighlight}
      </Pill>
    )}
  </div>
)
